import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_GEN_AI_DEMO_ISNA_4 = {
  title: "Contextualized follow-up \nanswer based on previous\n conversations",
  subtitle: "Gen AI Demo",
  text: "Ensuring a seamless and coherent flow in \n communication with the user, fostering a \n deeper understanding of the topic at hand.",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ENG_210"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_208"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/ISNA/ISNA_GEN_AI_Demo_01.jpg",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "ENG/ISNA/ISNA_GEN_AI_Demo_chat_frame.png",
          imageStyle: { position: "absolute", right: "166px" },
        },
        {
          image: "ENG/ISNA/ISNA_GEN_AI_Demo_04_bubble_1.png",
          imageStyle: {
            marginTop: "110px",
            marginLeft: "-40px",
          },
        },
        {
          image: "ENG/ISNA/ISNA_GEN_AI_Demo_04_bubble_2.png",
          imageStyle: {
            marginTop: "0px",
            paddingTop: "10px",
          },
        },
        {
          image: "ENG/ISNA/ISNA_GEN_AI_Demo_04_bubble_3.png",
          imageStyle: {
            marginTop: "-35px",
          },
        },
        {
          image: "ENG/ISNA/ISNA_GEN_AI_Demo_04_bubble_4.png",
          imageStyle: {
            marginTop: "-75px",
            marginLeft: "-40px",
          },
        },
      ]}
      pageNumber={"ENG_209"}
      conversationStyle={{
        width: "auto",
        alignItems: "center",
        marginRight: "90px",
      }}
    />
  ),
};
